import styles from './Chip.module.scss';
import { ChipProps } from './Chip.props';

export const Chip = ({ title, className, ...props }: ChipProps) => {
  return <div className={styles.Chip} {...props}></div>;
};
